let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aGsq7")).then(() => parcelRequire('eXmLL'));